/*
* 产品信息组件
*/

import { useState, useEffect } from 'react';
import { ConfigProvider, Row, Col, Modal, Button, Tag, Statistic, message, } from 'antd';
import { locale, Html2pdf } from '../incs/FunHelper.js';
import CNF from '../incs/Config.js';
import { AddRequestHeaders, UjoinParams } from '../incs/FunHelper.js';
import $ from 'jquery';
import XZTLOGO from '../images/logo_head.png';
import PAGEHEADERRIGHT from '../images/page-header-right.png';

/**
 * 显示供应商信息
 * @param {*} props 
 * @returns 
 */
const ProductInfo = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [record, setRecord] = useState(null);
    const cancel = () => { setOpen(false); };
    const printer = () => {
        var printContents = document.getElementById('print-info-id').innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload();
    };
    const download = () => {
        //  获取到产品实体信息才可以下载
        if (!record) return;
        setLoading(true);
        new Promise(function (resolve, reject) {
            try {
                Html2pdf('product-info-id', record.number, '');
                resolve();
            } catch {
                reject();
            }
        }).then(() => {
            cancel();
        }, () => {
            messageApi.success('下载失败！', CNF.messageDuration);
            setLoading(false);
        });
    };

    useEffect(() => {
        setOpen(props.open);
    }, [props]);

    useEffect(() => {
        setOpen(props.open);
        const getProductInfo = (number) => {
            const params = {
                'number': number,
                'page_size': 1,
                'current_index': 1
            };
            $.ajax({
                url: `${CNF.scmsApi}products${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET', success: function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            setRecord(data.dat[0]);
                        } else {
                            setRecord(null);
                        }
                    } else {
                        messageApi.error(data.msg, CNF.messageDuration);
                    }
                }
            })
        }
        getProductInfo(props.productNumber);
    }, [props, messageApi]);
    return (
        <ConfigProvider
            locale={locale}
            theme={{
                token: {
                    colorPrimary: global.THEMECOLOR,
                },
            }}
        >
            {contextHolder}
            <Modal
                width={820}
                style={{ top: 0 }}
                closable={false}
                open={open}
                keyboard={true}
                maskClosable={true}
                onCancel={cancel}
                footer={[
                    <Button key='back' onClick={cancel} disabled={loading}>取消</Button>,
                    <Button key='printer' type='primary' onClick={printer} disabled={loading}>打印</Button>,
                    <Button key='link' type='primary' onClick={download} disabled={loading} style={{ marginRight: 20 }}>下载</Button>,
                ]}
            >
                <div id='print-info-id'>
                    <div className='print-info' style={{ padding: '0 30px' }}>
                        <Row style={{ margin: '10px' }}>
                            <Col span={2}><img src={XZTLOGO} height='45px' alt={'新致腾'} /></Col>
                            <Col span={22} align='right'><img src={PAGEHEADERRIGHT} height='35px' alt='新致腾' /></Col>
                        </Row>
                        <table width='100%'>
                            <thead align='center'>
                                <tr>
                                    <th colSpan='24'><h2>产品信息表</h2></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>产品编码:</td><td colSpan='8' style={{ width: 240 }}>{record?.number}</td>
                                    <td colSpan='4' style={{ width: 120 }}>供应商编码:</td><td colSpan='8' style={{ width: 240 }}>{record?.supplier_number}</td>
                                </tr>
                                <tr><td colSpan='4' style={{ width: 120 }}>产品名称:</td><td colSpan='20' style={{ width: 600 }}>{record?.name}</td></tr>
                                <tr><td colSpan='4' style={{ width: 120 }}>供应商名称:</td><td colSpan='20' style={{ width: 600 }}>{record?.supplier_name}</td></tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>单位:</td><td colSpan='8' style={{ width: 240 }}>{record?.unit}</td>
                                    <td colSpan='4' style={{ width: 120 }}>单价:</td><td colSpan='8' style={{ width: 240 }}><Tag color={props.colorPrimaryBg}><Statistic precision={CNF.DPL} suffix={record?.price > 10000 ? '万元' : '元'} valueStyle={{ fontSize: CNF.fontSize - 2, color: global.THEMECOLOR }} value={record?.price > 10000 ? record?.price / 10000 : record?.price} /></Tag></td>
                                </tr>
                                <tr><td colSpan='4' style={{ width: 120 }}>品牌:</td><td colSpan='19' style={{ width: 600 }}>{record?.brand}</td></tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>型号:</td><td colSpan='8' style={{ width: 240 }}>{record?.model}</td>
                                    <td colSpan='4' style={{ width: 120 }}>产地:</td><td colSpan='8' style={{ width: 240 }}>{record?.origin}</td>
                                </tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>物料编码:</td><td colSpan='8' style={{ width: 240 }}>{record?.material_code}</td>
                                    <td colSpan='4' style={{ width: 120 }}>条形码:</td><td colSpan='8' style={{ width: 240 }}>{record?.bar_code}</td>
                                </tr>
                                <tr><td colSpan='4' style={{ width: 120 }}>产品描述:</td><td colSpan='20' style={{ width: 600 }}>
                                    {record && record.description.split('\n').map((item, index) => {
                                        return <p key={index} style={{ margin: 0 }}>{item}</p>;
                                    })}
                                </td></tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal>
        </ConfigProvider>
    );
};

export default ProductInfo